"use strict";
import DataStoreService from "./data_store_service";
import ApiService from "../services/api_service";
function completionCallback(data) {
  DataStoreService.updateStores(data);
  return true;
}
export default {
  _api_call: function(method, id, args) {
    return ApiService.addErrorHandler($.post(
      "/api/document_pages/" + id + "/" + method,
      args
    ).then(completionCallback));
  },
  _rotate: function(degrees, page) {
    var requested = page.rotation;
    requested += degrees;
    requested = requested % 360;
    page.inProcessRotation = degrees;
    return this._api_call("rotate", page.parent_id || page.id, { degrees: requested });
  },
  flip: function(page) {
    return this._rotate(180, page);
  },
  rotateRight: function(page) {
    return this._rotate(90, page);
  },
  rotateLeft: function(page) {
    return this._rotate(270, page);
  },
  split: function(documentId, pageId) {
    return ApiService.addErrorHandler(
      $.post(
        "/api/documents/" + documentId + "/split",
        { page_id: pageId }
      )
    ).then(completionCallback);
  },
  merge: function(currentDocumentId, intoDocumentId) {
    return ApiService.addErrorHandler(
      $.post(
        "/api/documents/" + currentDocumentId + "/merge",
        { into_document_id: intoDocumentId }
      )
    ).then(completionCallback);
  },
  duplicate: function(documentId) {
    return ApiService.addErrorHandler(
      $.post("/api/documents/" + documentId + "/duplicate")
    ).then(completionCallback);
  },
  documentFromEmail: function(emailMessageId, groupId) {
    return ApiService.addErrorHandler(
      $.post(
        "/api/documents/create_from_email",
        {
          document_group_id: groupId,
          email_message_id: emailMessageId
        }
      )
    ).then(completionCallback);
  },
  downloadURL: function(documentId) {
    return "/api/documents/" + documentId;
  },
  downloadAllURL: function(tokens) {
    return "//api.hubtran.com/downloads/documents/combined/" + tokens;
  }
};
